function UserPreference() {
    "use strict";

    this.__type = 'UserPreference:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;
    this.UserId = gUserDetails.UserId;
    this.ColumnName = '';
    this.UserPreferenceType = -1;
    this.Value = '';
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = UserPreference;
}